module.exports = __webpack_public_path__ + "img/deafultProduct.0d181440.png";